import { createYesNoOptions } from '@/config/formOptions';
import { buildRawMaterialTypeOptions } from '@/config/rawMaterialTypes.constants';
import { buildProductTypeOptions } from '@/config/productTypes.constants';
import { COUNTRY_CODES } from '@/config/countries.constants';
import { buildCountryOptions } from '@/lib/utils';
import {
  GHG_DEFAULT_VALUE,
  YES_NO_VALUE,
  CHAIN_OF_CUSTODY_OPTION,
  ESCA_BONUS_CAP,
} from '@/config/declarationOptions';

// Local option lists: the declarations hook also fetches lookups this form never asks for.

export const buildGhgDefaultOptions = createYesNoOptions(GHG_DEFAULT_VALUE);
export const buildYesNoOptions = createYesNoOptions(YES_NO_VALUE);

export const buildChainOfCustodyOptions = (t) => [
  { value: CHAIN_OF_CUSTODY_OPTION.massBalance, label: t('CHAIN_OF_CUSTODY_MASS_BALANCE') },
  {
    value: CHAIN_OF_CUSTODY_OPTION.physicalSegregation,
    label: t('CHAIN_OF_CUSTODY_PHYSICAL_SEGREGATION'),
  },
];

export const buildEscaBonusCapOptions = (t) => [
  { value: ESCA_BONUS_CAP.notClaimed, label: t('ESCA_BONUS_CAP_NOT_CLAIMED') },
  { value: ESCA_BONUS_CAP.manureBonus, label: t('ESCA_BONUS_CAP_MANURE_BONUS') },
  { value: ESCA_BONUS_CAP.noCapBefore2013, label: t('ESCA_BONUS_CAP_NO_CAP_BEFORE_2013') },
  { value: ESCA_BONUS_CAP.biofuelAfter2023, label: t('ESCA_BONUS_CAP_BIOFUEL_AFTER_2023') },
  { value: ESCA_BONUS_CAP.biocharUse, label: t('ESCA_BONUS_CAP_BIOCHAR_USE') },
  { value: ESCA_BONUS_CAP.priorEscaClaims, label: t('ESCA_BONUS_CAP_PRIOR_ESCA_CLAIMS') },
];

export const buildDeclarationCountryOptions = () => buildCountryOptions(COUNTRY_CODES);
export { buildRawMaterialTypeOptions, buildProductTypeOptions };
